import { TFunction } from 'i18next';

export type CompanyRelationship = 'customer' | 'prospect' | 'partner' | 'none';

export const COMPANY_RELATIONSHIPS: CompanyRelationship[] = ['customer', 'prospect', 'partner', 'none'];

export const isCompanyRelationship = (v: unknown): v is CompanyRelationship =>
	typeof v === 'string' && (COMPANY_RELATIONSHIPS as string[]).includes(v);

export const getRelationshipLabel = (rel: CompanyRelationship, t: TFunction): string =>
	t(`companies.relationship.${rel}`);

export const getRelationshipBadgeClasses = (rel: CompanyRelationship): string => {
	switch (rel) {
		case 'customer':
			return 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300';
		case 'prospect':
			return 'bg-blue-50 text-blue-700 dark:bg-blue-950 dark:text-blue-300';
		case 'partner':
			return 'bg-purple-50 text-purple-700 dark:bg-purple-950 dark:text-purple-300';
		case 'none':
		default:
			return 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400';
	}
};
